import React, { useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { StyleSheet } from 'react-native';
import { AppView, Button, CollapsableContainer, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { useAppSelector } from 'store/hooks';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import ListEmptyView from 'design-system/ListEmptyView';
import { selectSelectedSpaceData } from './reducers/selectors';
import { AccountItem } from './components';
import { isWeb } from '../../constants';
import { useMySpaceAccounts } from './hooks/useMySpaceAccounts';
const FindSpaceAccounts = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const onSwitch = useCallback(() => {
        navigation.navigateDeprecated('MySpaces');
    }, []);
    const currentSpace = useAppSelector(selectSelectedSpaceData);
    const { mySpaceAccounts } = useMySpaceAccounts();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyles = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={contentContainerStyles}>
          <ScreenInfoHeader title="Why can’t I find my accounts?" subTitle={`You’re currently in the ${(currentSpace?.isDefault ? 'Private' : currentSpace?.name) || ''} Space. Some of your accounts are in other Spaces. Below is a full breakdown of where your accounts are located.`}/>
          {!mySpaceAccounts.length ? (<ListEmptyView compact onCard title="You don’t have any accounts."/>) : (
        // TODO: use FlashList/FlatList
        mySpaceAccounts.map((item) => item.accounts.length > 0 ? (<CollapsableContainer key={item.space.id || 'default'} title={item.space.isDefault ? 'Private space' : item.space.name} style={styles.itemContainer} isCollapsedByDefault={false}>
                  {item.accounts.map((account) => (<AccountItem hideSpaceUserAvatar key={account.id} account={account} disabled/>))}
                </CollapsableContainer>) : null))}
        </Animated.ScrollView>
        <Button brand floating title="Switch space" onPress={onSwitch}/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Find accounts',
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    itemContainer: {
        marginHorizontal: rem(16),
        marginBottom: rem(16),
    },
});
export default FindSpaceAccounts;
